// Feature overrides — retour Julien 2026-06-01 (point #10 Option B).
// Whitelist runtime de 4 features que l'admin peut moduler par rôle.
import { supabase } from '../../lib/supabaseClient';
import type { CollaboratorRole } from '../auth/permissions';

export const EDITABLE_FEATURES = [
  'dossiers_create',
  'tickets_assign',
  'contacts_import',
  'billing_view',
] as const;

export type EditableFeature = (typeof EDITABLE_FEATURES)[number];

export interface FeatureOverride {
  feature: EditableFeature;
  allowed_roles: CollaboratorRole[];
  updated_at: string;
  updated_by: string | null;
}

export async function listFeatureOverrides(): Promise<FeatureOverride[]> {
  const { data, error } = await supabase.from('feature_overrides').select('*');
  if (error) throw new Error(`Failed to list feature overrides: ${error.message}`);
  return (data ?? []) as FeatureOverride[];
}

export async function updateFeatureOverride(
  feature: EditableFeature,
  allowedRoles: CollaboratorRole[],
): Promise<FeatureOverride> {
  const { data, error } = await supabase.rpc('update_feature_override', {
    p_feature: feature,
    p_allowed_roles: allowedRoles,
  });
  if (error) throw new Error(`Failed to update feature override: ${error.message}`);
  if (!data) throw new Error('update_feature_override returned no data');
  return data as FeatureOverride;
}
